import React, { useState } from "react"
import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000"

function AdminLogin({ onLoginSuccess }) {
    const [credentials, setCredentials] = useState({ username: "", password: "" })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const handleChange = (e) => {
        const { name, value } = e.target
        setCredentials(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!credentials.username || !credentials.password) {
            setError("Please enter both username and password")
            return
        }
        setLoading(true)
        setError("")
        try {
            const response = await axios.post(`${API_URL}/api/admin/login`, credentials)
            localStorage.setItem("adminToken", response.data.token)
            localStorage.setItem("adminUsername", response.data.admin.username)
            onLoginSuccess(response.data.admin)
            setCredentials({ username: "", password: "" })
        } catch (error) {
            console.error("Login error:", error)
            setError(error.response?.data?.error || "Login failed. Please try again.")
        } finally { setLoading(false) }
    }

    return (
        <div className="admin-login-container">
            <h3>Admin Login</h3>
            <form onSubmit={handleSubmit} className="admin-login-form">
                <div className="form-group">
                    <label>Username</label>
                    <input type="text" name="username" value={credentials.username} onChange={handleChange} placeholder="Enter username" autoComplete="username" />
                </div>
                <div className="form-group">
                    <label>Password</label>
                    <input type="password" name="password" value={credentials.password} onChange={handleChange} placeholder="Enter password" autoComplete="current-password" />
                </div>
                <button type="submit" className="login-btn" disabled={loading}>
                    {loading ? "Logging in..." : "Login"}
                </button>
                {error && <div className="error-message">{error}</div>}
            </form>
        </div>
    )
}

export default AdminLogin
